import React from "react";
import AvatarComponent from "./AvatarComponent";
import { UserMinus } from "lucide-react";
import toast from "react-hot-toast";
import api from "@/services/api";
import { useTranslation } from "react-i18next";

const FriendList = ({ friends, onRefresh}) => {
  const { t } = useTranslation();

  const handleRemove = async (friendId) => {
    toast((toastInstance) => (
        <div className="flex items-center gap-3">
            <span className="text-sm">{t("friendList_removeConfirmTitle")}</span>
            <button
                onClick={async () => {
                    try {
                        await api.delete(`/friendships/remove/${friendId}`);
                        toast.success(t("friendList_removeSuccess"));
                        onRefresh();
                    } catch (err) {
                        console.error(err);
                        toast.error(t("friendList_removeError"));
                    }
                    toast.dismiss(toastInstance.id);
                }}
                className="text-xs text-red-400 hover:text-red-300"
            >
                {t("friendList_removeConfirmYes")}
            </button>
            <button
                onClick={() => toast.dismiss(toastInstance.id)}
                className="text-xs text-zinc-400 hover:text-zinc-300"
            >
                {t("friendList_removeConfirmCancel")}
            </button>
        </div>
    ));
  };

  if (friends.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-48 gap-2 text-center border border-white/8 rounded-xl">
        <span className="text-zinc-500 text-sm">{t("friendList_emptyTitle")}</span>
        <span className="text-zinc-600 text-xs">
          {t("friendList_emptyDescription")}
        </span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {friends.map((friend) => (
        <div
          key={friend.id}
          className="flex items-center gap-3 px-4 py-3 rounded-xl border border-white/8 hover:bg-white/3 transition-colors"
        >
          {/* Avatar */}
          <div className="relative">
            <AvatarComponent userId={friend.id} username={friend.username} />
            <span
              className={`absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full border-2 border-zinc-900
                  ${friend.online ? "bg-green-500" : "bg-zinc-600"}`}
            />
          </div>

          {/* Info */}
          <div className="flex flex-col">
            <span className="text-sm text-white font-medium">
              {friend.username}
            </span>
            <span
              className={`text-xs ${friend.online ? "text-green-400" : "text-zinc-500"}`}
            >
              {friend.online ? t("friendList_online") : t("friendList_offline")}
            </span>
          </div>
          <button className="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs text-zinc-500 hover:text-red-400 hover:bg-red-400/10 border border-transparent hover:border-red-400/20 transition-all"
                  onClick={() => handleRemove(friend.id)}
          >
            <UserMinus size={14} />
            {t("friendList_removeButton")}
          </button>
        </div>
      ))}
    </div>
  );
};

export default FriendList;
